import Modal, { ModalContainer } from '../common/Modal'
import { useSelector } from 'react-redux'; 
import { closeAllModal, closeModal } from '@store/modalsSlise';
import { useDispatch } from 'react-redux';
import s from './index.module.css'
import classNames from 'classnames';
import { Suspense, useCallback, useState } from 'react';
import { actions } from '@pages/Main/Timetable/actionsEnum';
import modalsList from './modalsList';
import TYPES from './TYPES';
import Preloader from '@UI/Preloader';

const Modals = () => {
    const modals = useSelector((state) => state.modals);
    const [closeLocks, setCloseLocks] = useState({});

    const dispatch = useDispatch();

    const isCloseLocked = (type) => !!closeLocks[type];

    const handleCloseAllModal = () => {
        if (currentList.some((modal) => isCloseLocked(modal.name))) return;
        dispatch(closeAllModal());
    };
    const handleCloseModal = ({type=''}) => {
        if(!type) return;
        if(isCloseLocked(type)) return;
        dispatch(closeModal({type}));
    };

    const setModalCloseLocked = useCallback((type, locked) => {
        setCloseLocks((prev) => {
            if (prev[type] === locked) return prev;
            return { ...prev, [type]: locked };
        });
    }, []);

    const minSizeModalTypes = [
        'bulkUpload',
        actions.addLessonOrMeeting,
        actions.intersectionCheck,
        actions.editLessonOrMeeting,
        actions.showLessonOrMeeting,
        actions.addingToPlanningTable,
        actions.registerLesson,
        actions.addGroups,
        actions.downloadImageWithCustomTitle,
        TYPES.UPLOADING_FILES_TO_MEDIA_PLATFORMS,
        TYPES.EDIT_DIRECTION_COPY,
        TYPES.JOURNAL_DOWNLOAD_EXCEL,
        TYPES.JOURNAL_BUTTONS_GRADES_COURSE,
        TYPES.TIPTAP_RESIZE_IMAGE,
        TYPES.SELECT_FILES_FROM_MEDIA_PLATFORM,
        TYPES.DEPARTMENTS_SELECT,
        TYPES.CHANGE_DEADLINE,
        TYPES.CREATE_WELCOME_MESSAGE,
        TYPES.LIST_OF_PERSONAL_ACCOUNTS,
        TYPES.AI_COURSE_STRUCTURE_GENERATOR,
        TYPES.REPORTS_VISIBILITY,
        TYPES.TIMETABLE_AUDIENCE_FORM,
        TYPES.TIMETABLE_AUDIENCE_REPLACE,
        TYPES.CHAT_FOLDERS,
        TYPES.DELAYED_MESSAGE
    ];

    const currentList = modalsList.filter(el => modals.types.includes(el.name));
    
    return (
        <>
            {
                currentList.map((el, i) => {
                    const Component = el.component;
                    const modalMinSize = minSizeModalTypes.includes(el.name);
                    const isAddLessonOrMeeting =
                        el.name === actions.addLessonOrMeeting;
                    const isJournalDownloadSettings =
                        el.name === TYPES.JOURNAL_DOWNLOAD_SETTINGS;
                    const isChatFolders = el.name === TYPES.CHAT_FOLDERS;
                    return (
                        <Modal key={el.name} className={classNames(
                            s.modal,
                            {[s.modalMin]: modalMinSize},
                            {[s.addLessonModal]: isAddLessonOrMeeting},
                            {[s.journalDownloadSettingsModal]: isJournalDownloadSettings}
                        )}
                            classNameBackground={classNames({
                                [s.addLessonModalBackground]: isAddLessonOrMeeting
                            })}
                            active={!!modals.types.length} 
                            setActive={() => {currentList?.length === 1 && handleCloseAllModal() }}
                            style={{zIndex: `${(isChatFolders ? 112 : 104) + modals.types?.indexOf(el.name)}`}}
                        >
                            <ModalContainer
                                className={classNames(
                                    {[s.modalContainerMin]: modalMinSize},
                                    {[s.addLessonModalContainer]: isAddLessonOrMeeting},
                                    {[s.journalDownloadSettingsContainer]: isJournalDownloadSettings}
                                )}
                                closeModal={() => handleCloseModal({type: el.name})}
                                closeDisabled={isCloseLocked(el.name)}
                            >           
                                <Suspense fallback={<Preloader align='center' />}>
                                    <Component
                                        closeModal={() => handleCloseModal({type: el.name})}
                                        modalType={el.name}
                                        setModalCloseLocked={setModalCloseLocked}
                                        data={modals.data[el.name]}
                                    />
                                </Suspense>
                            </ModalContainer>
                        </Modal>
                    )
            })
        }
        </>
    )
}

export default Modals;
